const sellersJsonAdapter = s => ({
  id: s.id,
  ...s.attributes,
  relationships: {
    ...s.relationships,
  },
});

export default sellersJsonAdapter;
